import { apiErrorToToast, forceFileDownload } from "@/lib/utils";
import {
  downloadFileResource,
  DownloadFileResourceRequestParams,
} from "@/requests/libraries/download-file-resource.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

type Params = DownloadFileResourceRequestParams & {
  fileName?: string;
};

export const useDownloadFileResourceMutation = () => {
  return useMutation({
    mutationFn: (variables: Params) => downloadFileResource(variables),
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (response, variables) => {
      let fileName = variables.fileName || "";

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const contentDisposition = response.headers["content-disposition"];

      if (!fileName && contentDisposition) {
        const match = contentDisposition?.match(/filename="(.+?)"/);
        fileName = match ? match[1] : null;
      }

      forceFileDownload(url, fileName || "descarga.pdf");
    },
  });
};
